import { createApp } from 'vue';
import WebpToPngConverter from '../Components/WebpToPngConverter.vue';

const root = document.getElementById('webp-to-png-converter');
if (root) {
  createApp(WebpToPngConverter).mount('#webp-to-png-converter');
}
